import React, { useState, useEffect } from 'react';
import '../../urunDiv.css';
import '../icecekler/sicak-kahveler/KahveDetay.css';
import comboSicakTabagi from '../../../assets/menu/yemekler/dostluk-pekistirenler/combo-sicak-tabagi.png';

const ComboSicakTabagi = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const yemek = {
    name: 'Combo Sıcak Tabağı (4 Kişilik)',
    price: '₺1499,90',
    image: comboSicakTabagi,
    description: '4 kişilik özel combo sıcak tabağı. Çeşitli sıcak yemekler, patates ve özel soslarla birlikte servis edilir. Arkadaşlarınızla paylaşmak için ideal.'
  };

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default ComboSicakTabagi;
